module.exports = __webpack_public_path__ + "static/media/lock-opened.7756afe6.svg";